import React, { useEffect, useState } from "react";

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import "react-tagsinput/react-tagsinput.css";

import { updateSource } from "helpers/Sources/updateSource";

import "../css/createSourceModal.css";
import { getAllSourcesRedux } from "../redux/slices/sources/sources.asyncActions";
import { getSourcesTypesRedux } from "../redux/slices/sourcesTypes/sourcesTypes.asyncActions";
import SwalAlertComp from "./SwalAlert";

const UpdateSourceModal = (props) => {
    const dispatch = useDispatch();
    const [updateDomain, setUpdateDomain] = useState(props.sourceName);
    const [show, setShow] = useState(true);
    const [isChecked, setIsChecked] = useState(
        props.generic === 1 ? true : false,
    );
    const language = useSelector((state) => state.languagesState.languages);
    const id = props.sourceId;
    const sourceHost = props.host;
    const hostFisrt = sourceHost.split(".");
    const hostNameFisrt = hostFisrt?.slice(1).join(".");
    const hostNameSecond = sourceHost?.split(".")[0];
    const [updateHostDomain, setUpdateHostDomain] = useState(hostNameFisrt);
    const [form, setForm] = useState(hostNameSecond);
    const handleClose = () => {
        setShow(false);
        props.handleCloseUpdateSourceModal();
    };
    useEffect(() => {
        dispatch(getSourcesTypesRedux(props.tracker_id && props.tracker_id));
    }, [dispatch]);
    const sourcesTypes = useSelector(
        (state) => state.allSourcesTypesState.sources,
    );
    const handleUptadeSource = () => {
        if (isChecked) {
            let updateData = {
                domain: updateDomain && updateDomain,
                host: "cpi.ssevt.com",
                is_generic: isChecked ? 1 : 0,
            };
            updateSourceAsync(id, updateData);
            props.setHandleShowUpdateSourceModalState(false);
        } else {
            let updateData = {
                domain: updateDomain && updateDomain,
                host: `${form}.${updateHostDomain}`,
                is_generic: isChecked ? 1 : 0,
            };
            updateSourceAsync(id, updateData);
            props.setHandleShowUpdateSourceModalState(false);
        }
    };
    const updateSourceAsync = async (id, updateData) => {
        let response = await updateSource(id, updateData);
        if (response.status) {
            SwalAlertComp({
                title: language?.delete_swal_modal?.success ?? "Success",
                message: response.message && response.message,
                icon: "success",
                timer: 3000,
            });
            dispatch(getAllSourcesRedux());
            if (props.getTracker) {
                props.getTracker();
            }
        }
    };

    const getForm = () => (
        <Form>
            <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
            >
                <Form.Label>
                    {language?.source_modal?.source_types ?? "Source Type"}
                </Form.Label>
                <Form.Control className="d-flex align-items-center" as="text">
                    {sourcesTypes &&
                        sourcesTypes.length &&
                        (
                            sourcesTypes.find(
                                (item) =>
                                    item.code ===
                                    (props?.sourceType !== undefined
                                        ? props?.sourceType
                                        : "js"),
                            ) || {
                                name:
                                    props?.sourceType !== undefined
                                        ? props?.sourceType === "js"
                                            ? "Web Site Javascript"
                                            : "Link Event"
                                        : "Web Site Javascript",
                            }
                        ).name}
                </Form.Control>
            </Form.Group>
            <div className="row mt-1">
                <Form.Group
                    className="mb-3 col"
                    controlId="exampleForm.ControlInput1"
                >
                    <Form.Label>
                        {language?.source_modal?.domain ?? "Domain"}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        value={updateDomain}
                        placeholder="https://www.example.com"
                        autoFocus
                        onChange={(e) => setUpdateDomain(e.target.value)}
                    />
                </Form.Group>
            </div>
            <>
                <Form.Group controlId="formBasicCheckbox">
                    <Form.Check
                        onChange={(e) => setIsChecked(Number(e.target.checked))}
                        className="mt-3"
                        type="checkbox"
                        label={
                            language?.source_modal?.use_generic_domain ??
                            "Use generic domain"
                        }
                        checked={isChecked}
                    />
                </Form.Group>
                {!isChecked && (
                    <>
                        <Form.Label className="mt-4">
                            {language?.source_modal?.signal_host_name ??
                                "Signal Host Name"}
                        </Form.Label>
                        <div className="row">
                            <div className="col-4">
                                <Form.Group
                                    className="mb-3"
                                    controlId="exampleForm.ControlInput1"
                                >
                                    <Form.Control
                                        type="text"
                                        autoFocus
                                        value={form}
                                        onChange={(e) =>
                                            setForm(e.target.value)
                                        }
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-8">
                                <Form.Group
                                    className="mb-3"
                                    controlId="exampleForm.ControlInput1"
                                >
                                    <Form.Control
                                        type="text"
                                        placeholder="example.com"
                                        autoFocus
                                        value={updateHostDomain}
                                        onChange={(e) =>
                                            setUpdateHostDomain(e.target.value)
                                        }
                                    />
                                </Form.Group>
                            </div>
                        </div>
                    </>
                )}
            </>
        </Form>
    );

    return (
        <div>
            {props?.isModal !== undefined && props?.isModal === false ? (
                <div>
                    <Modal.Body>{getForm()}</Modal.Body>
                    <Modal.Footer>
                        <Button
                            color="error"
                            variant="contained"
                            onClick={handleClose}
                        >
                            {language?.buttons?.close ?? "Close"}
                        </Button>
                        <Button
                            className="source-button"
                            onClick={handleUptadeSource}
                        >
                            {language?.buttons?.update_source ??
                                "Update Source"}
                        </Button>
                    </Modal.Footer>
                </div>
            ) : (
                <Modal show={show} onHide={handleClose}>
                    <Modal.Header>
                        <Modal.Title>
                            {language?.source_modal?.update_source ??
                                "Update Source"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{getForm()}</Modal.Body>
                    <Modal.Footer>
                        <Button
                            color="error"
                            variant="contained"
                            onClick={handleClose}
                        >
                            {language?.buttons?.close ?? "Close"}
                        </Button>
                        <Button
                            className="source-button"
                            onClick={handleUptadeSource}
                        >
                            {language?.buttons?.update_source ??
                                "Update Source"}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </div>
    );
};

export default UpdateSourceModal;
